import { ChevronRight, Phone } from "react-feather";
import { Button } from "reactstrap";
import NavbarSms from "../../../../../@core/layouts/components/navbar/NavbarSms";

const KeywordAction = (props) => {
  const {
    keywordAction,
    onContinue,
    onCancel,
    shop,
  } = props;

  const formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return '';
    return [
      phoneNumber.slice(0, 3),
      phoneNumber.slice(3, 6),
      phoneNumber.slice(6)
    ].join('-');
  };

  return (
    <div className="keyword-action-wrapper">
      <div className="keyword-action-body mb-1">
        <p>{keywordAction?.info_message}</p>
      </div>
      <div className="keyword-action-footer">
        {!keywordAction?.allow_bypass && (
          <>
            <div
              className="d-flex align-items-center justify-content-center flex-column"
              style={{
                borderRadius: '25px',
                fontFamily: 'Spartan',
                border: '1px solid #E5E5E5',
                padding: '15px 20px',
                marginBottom: '24px',
              }}
            >
              <p>Call us:</p>
              <Button
                style={{
                  paddingTop: '6px',
                  paddingBottom: '4px',
                  paddingLeft: '12px',
                  paddingRight: '12px',
                  borderRadius: '20px',
                  border: '1px solid #03464C',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  fontSize: '14px',
                  fontWeight: 'bold',
                  color: '#03464C',
                  marginBottom: '12px',
                }}
                href={`tel:${shop?.phone}`}
              >
                <Phone className='mr-1' />
                {formatPhoneNumber(shop?.phoneNumber)}
              </Button>
              <NavbarSms buttonText="or text us" />
            </div>
          </>
        )}
        {keywordAction?.action_type === 'prompt' && (
          <Button
            type="button"
            color="primary"
            outline
            className="custom-client-type-picker-button mb-2"
            onClick={onCancel}
          >
            Go back
          </Button>
        )}
        {keywordAction?.allow_bypass && (
          <Button
            type="button"
            color="primary"
            className="custom-client-type-picker-button"
            onClick={onContinue}
          >
            <>
              {keywordAction?.action_type === 'prompt' ? (
                <>
                  {keywordAction?.prompt_message}
                </>
              ) : (
                <>
                  Continue
                </>
              )}
              <ChevronRight style={{ marginLeft: '5px' }} size={18} />
            </>
          </Button>
        )}
      </div>
    </div>
  );
};

export default KeywordAction;
